module.exports = __webpack_public_path__ + "img/prev-expo.f4c2c68d.svg";